export default "__VITE_ASSET__0f586f1d__"